module.exports = __webpack_public_path__ + "img/故城压力容器.7f3f6c9f.jpg";